"use client";

import styles from "./Form.module.scss";
import { useState } from "react";
import sendDiningForm from "../../../lib/sendDiningForm";
import useDiningForm from "../../../hooks/useDiningForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import sendCorporateForm from "../../../lib/sendCorporateForm";
import useCorporateForm from "../../../hooks/useCorporateForm";

export default function CorporateToursForm() {
    const [selectDate, setSelectDate] = useState(new Date());
    const [selectedOption, setSelectedOption] = useState('');
    const [formMessage, setFormMessage] = useState('');
    const { values, handleChange } = useCorporateForm();

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const datenmonth = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });

    const handleDateChange = (date) => {
        setSelectDate(date);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormMessage({ state: 'loading' })
        setTimeout(() => {
            setFormMessage({ state: 'success' }),
                values.companyName = "",
                values.fullname = "",
                values.email = "",
                values.phoneno = "",
                values.message = "",
                values.noofguests = "",
                setSelectDate(new Date())
        }, 4000)
        try {
            const req = await sendCorporateForm(values.companyName, values.email, values.phoneno, values.fullname, values.noofguests, selectDate, values.message);
            if (req.status === 250) {
                setResponseMessage({ isSuccessful: true, message: 'Thank you for your message.' });

                alert("Thank you for your message.")
            }


        } catch (e) {
            console.log(e);
            setFormMessage({ state: 'error' })
        }
    };

    return (
        <>
            <section className={`${styles.form} common_padding pb-0`}>
                <div className="row">
                    <div className="col-md-8 offset-md-2 col-sm-12 contact_form">
                        <form className="row" onSubmit={handleSubmit}>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="companyName"
                                    type="text"
                                    name="companyName"
                                    onChange={handleChange}
                                    value={values.companyName}
                                    className="form-control"
                                    placeholder="Company Name"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    className="form-control"
                                    placeholder="Your Email"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="fullname"
                                    type="text"
                                    name="fullname"
                                    onChange={handleChange}
                                    value={values.fullname}
                                    className="form-control"
                                    placeholder="Your Name"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <input
                                    id="phoneno"
                                    required
                                    name="phoneno"
                                    type="number"
                                    onChange={handleChange}
                                    value={values.phoneno}
                                    className="form-control"
                                    placeholder="Phone Number"
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <select
                                    id="noofguests"
                                    required
                                    name="noofguests"
                                    onChange={handleChange}
                                    value={values.noofguests}
                                    className="form-control"
                                >
                                    <option value="">No of Guests</option>
                                    <option value="10 - 50">10 - 50</option>
                                    <option value="50 - 100">50 - 100</option>
                                    <option value="100 - 150">100 - 150</option>
                                    <option value="150 - 200">150 - 200</option>
                                </select>
                            </div>

                            <div className={`${styles.form_group} col-md-6`}>
                                <DatePicker wrapperClassName="diningform-date-picker"
                                    minDate={new Date()}
                                    className={styles.form_control}
                                    selected={selectDate}
                                    onChange={handleDateChange}
                                    placeholderText={'Please select a date'}
                                />
                            </div>
                            {/* <div className={`${styles.form_group} col-md-12`}>
                                <div className="dining-radio-input">
                                    <span className="me-2"><strong>Booking For:</strong></span>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Restaurant"
                                            checked={selectedOption === 'Restaurant'}
                                            onChange={handleOptionChange}
                                        />
                                        Restaurant
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Bar"
                                            checked={selectedOption === 'Bar'}
                                            onChange={handleOptionChange}
                                        />
                                        Bar
                                    </label>
                                </div>
                            </div> */}
                            <div className={`${styles.form_group} col-md-12`}>
                                <textarea
                                    id="message"
                                    name="message"
                                    onChange={handleChange}
                                    value={values.message}
                                    className="form-control"
                                    placeholder="Message"
                                    required
                                ></textarea>
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <button type="submit" className="secoundary_btn" style={{ width: '100%' }}>Get Quote</button>
                            </div>
                            {formMessage.state === 'loading' ? (
                                <div>Sending....</div>
                            ) : formMessage.state === 'error' ? (
                                <div className="form_message error">Something went wrong! Try again later.</div>
                            ) : (
                                formMessage.state === 'success' && <div className="success">Thankyou! Your Message has been delivered.</div>
                            )}
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}
